import { FC, memo, useCallback, useEffect, useMemo } from "react"
import { useShops } from "@/hooks/shops/shops"
import { ShopType } from "@/hooks/shops/types"
import { StyledShopsMap } from "./StyledShopsMap"
import { ShopList } from "../List"
import { ShopMap } from "../ShopMap"
import { ListMapPropsType } from "../types"

const ListMap: FC<ListMapPropsType> = memo(
  ({
    shops: shopsOut,
    withRouteToDetail,
    shopBody,
    selectedShopId,
    onSelectShop,
    enableSelectShop = false,
    extendElements,
    activatedShopId,
  }) => {
    const {
      activatedShop,
      setActivatedShop,
      shops,
      selectedShop,
      setSelectedShop,
    } = useShops()

    const shopsPickup = useMemo(() => {
      const shopsData = !shopsOut
        ? Object.entries(shops || {}).map(([, shop]) => shop)
        : shopsOut

      return shopsData.filter((item) => !!item.pickup)
    }, [shops, shopsOut])

    const activated = useMemo(
      () =>
        shops !== null && activatedShop !== null
          ? shops[activatedShop] || null
          : null,
      [activatedShop, shops],
    )

    const onSelectHandle = useCallback(
      ({ uuid }: ShopType) => {
        setActivatedShop(uuid)
      },
      [setActivatedShop],
    )

    useEffect(() => {
      setSelectedShop(selectedShopId || null)
    }, [selectedShopId, setSelectedShop])

    useEffect(() => {
      setActivatedShop(activatedShopId || null)
    }, [activatedShopId, setActivatedShop])

    if (!shopsPickup.length) {
      return (
        <StyledShopsMap>Магазинов для самовывоза не найдено</StyledShopsMap>
      )
    }

    return (
      <StyledShopsMap>
        <ShopList
          onNameClick={onSelectHandle}
          activatedShop={activated}
          selectedShopId={selectedShop || undefined}
          shops={shopsPickup}
          withRouteToDetail={withRouteToDetail}
          shopBody={shopBody}
          onSelectShop={onSelectShop}
          enableSelectShop={enableSelectShop}
          extendElements={extendElements}
        />
        <ShopMap
          onPlacemarkClick={onSelectHandle}
          onBalloonClose={() => {
            setActivatedShop(null)
          }}
          activatedShop={activated}
          shops={shopsPickup}
        />
      </StyledShopsMap>
    )
  },
)

ListMap.displayName = "ListMap"

export { ListMap }
